import { HeatMapValues, State } from '@/views/heat-map-configuration/heat-map-configuration.types';

const mutations = {
  setHeatMapConfiguration(state: State, payload: HeatMapValues[]) {
    state.heatMapValues = payload;
  },
};

export default mutations;
